export default __webpack_public_path__ + "static/media/info.a0f97458.svg";